import { useMemo } from 'react';
import { useSignerContext } from 'signer-app/signer-experience/signer-experience';

export function useAttachmentsInfo() {
  const { attachmentSlots } = useSignerContext();

  const requiredAttachments = useMemo(() => {
    return attachmentSlots.filter((slot) => slot.required);
  }, [attachmentSlots]);

  const requiredAttachmentsUploaded = useMemo(() => {
    return requiredAttachments.filter((slot) => slot.uploadedAt).length;
  }, [requiredAttachments]);

  const requiredAttachmentsLeft = useMemo(() => {
    return requiredAttachments.length - requiredAttachmentsUploaded;
  }, [requiredAttachments, requiredAttachmentsUploaded]);

  const hasAttachments = useMemo(() => {
    return attachmentSlots.length > 0;
  }, [attachmentSlots]);

  const optionalAttachments = useMemo(() => {
    return attachmentSlots.filter((slot) => !slot.required);
  }, [attachmentSlots]);

  const optionalAttachmentsUploaded = useMemo(() => {
    return optionalAttachments.filter((slot) => slot.uploadedAt).length;
  }, [optionalAttachments]);

  return {
    requiredAttachmentsNumber: requiredAttachments.length,
    requiredAttachmentsUploaded,
    requiredAttachmentsLeft,
    hasAttachments,
    optionalAttachmentsNumber: optionalAttachments.length,
    optionalAttachmentsUploaded,
  };
}
